import NumberFlow, { type NumberFlowProps } from '@number-flow/react';
import classNames from 'classnames';

// accepts strings with $ % commas, and numbers
export const CustomNumberFlow = ({
  value,
  fallback,
  className = '',
  isInteger = false,
  ...props
}: {
  value: string | number | bigint;
  fallback?: string | number | bigint;
  isInteger?: boolean;
} & Omit<NumberFlowProps, 'value'>) => {
  let willNaN = false;
  let isDollar = false;
  let isPercent = false;
  if (typeof value === 'string') {
    // Check if the string contains any characters other than digits, comma, $ or %
    if (/[^0-9,.$%]/.test(value)) {
      willNaN = true;
    }
    isDollar = value.includes('$');
    isPercent = value.includes('%');
  }

  if (value === '') {
    return (
      <span data-testid="number-flow-span" data-value="-">
        -
      </span>
    );
  }

  const number = Number(value.toString().replace(/,|\$|%/g, ''));

  return willNaN ? (
    <span>{fallback ? fallback.toString() : value.toString()}</span>
  ) : (
    <div className={classNames('inline-flex  items-center gap-x-0.5', className)}>
      {isDollar && <span>$</span>}
      <NumberFlow
        value={number}
        {...props}
        format={{
          minimumFractionDigits: isInteger ? 0 : 2,
          maximumFractionDigits: isInteger ? 0 : 2,
        }}
      />
      {isPercent && <span>%</span>}
    </div>
  );
};
